module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-image fmcy-loader-region"></div>\n<div class="fmcy-large-image"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/product-tile/image-display/image-display.html
 ** module id = 86
 ** module chunks = 1 2 3 4 5 6 7 9 10 11 13 14 15 16 17 22 25 26 29 32 38 49 67 79 117
 **/